
<div><span style="cursor: pointer;" (click)="toggleDetailsDisplay = !toggleDetailsDisplay"><b>More Details:</b><a class="nav-link" href="javascript:void(0);" style="display: inline;" aria-haspopup="true" aria-expanded="false" *ngIf="toggleDetailsDisplay &amp;&amp; !IsParrtiallySuccess"><span class="icon oi oi-chevron-top alert-danger"></span></a><a class="nav-link" href="javascript:void(0);" style="display: inline;" aria-haspopup="true" aria-expanded="false" *ngIf="!toggleDetailsDisplay &amp;&amp; !IsParrtiallySuccess"><span class="icon oi oi-chevron-bottom alert-danger"></span></a><a class="nav-link" href="javascript:void(0);" style="display: inline;" aria-haspopup="true" aria-expanded="false" *ngIf="toggleDetailsDisplay  &amp;&amp; IsParrtiallySuccess"><span class="icon oi oi-chevron-top alert-warning"></span></a><a class="nav-link" href="javascript:void(0);" style="display: inline;" aria-haspopup="true" aria-expanded="false" *ngIf="!toggleDetailsDisplay &amp;&amp; IsParrtiallySuccess"><span class="icon oi oi-chevron-bottom alert-warning"> </span></a></span>
  <div *ngIf="toggleDetailsDisplay">
    <table>
      <tbody>
        <tr *ngFor="let sa of summaryArray">
          <td>{{sa.key}}</td>
          <td>:</td>
          <td style="padding: 0 0.5rem;">{{sa.value}}</td>
        </tr>
      </tbody>
    </table>
    <table *ngIf="errorsDetailsList.length &gt; 0">
      <tr>
        <td style="vertical-align: top; text-wrap: nowrap;">Error Details</td>
        <td style="vertical-align: top;">:</td>
        <td> 
          <div>
            <ul>
              <li *ngFor="let det of errorsDetailsList" style="overflow-wrap: break-word; word-break: break-all; white-space: pre-wrap;">{{det}}</li>
            </ul>
          </div>
        </td>
      </tr>
    </table>
    <div *ngIf="errorsTableList.length &gt; 0">
      <div>Error Details:</div>
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th *ngFor="let key of objectKeys(errorsTableList[0])">{{ transformKey(key) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of errorsTableList">
            <td *ngFor="let key of objectKeys(row)">{{ row[key] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <table *ngIf="contextInfoArray.length &gt; 0">
      <tbody>
        <tr>
          <td><b>Context Information</b></td>
          <td>:</td>
          <td> </td>
        </tr>
      </tbody>
    </table>
    <div style="padding-left: 2.5rem;">
      <table>
        <tbody>
          <tr *ngFor="let ca of contextInfoArray">
            <td style="overflow-wrap: anywhere;width: 187px; text-align: start; vertical-align: initial;">{{ca.key}}</td>
            <td style="text-align:start; vertical-align:initial;">:</td>
            <td style="padding: 0 0.5rem;"> 
              <div *ngFor="let line of ca.value" style="overflow-wrap: break-word; word-break: break-all; white-space: pre-wrap;">{{line}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div><a class="btn btn-danger" *ngIf="isDisplayPossibleResolutionButton" href="javascript:void(0)" (click)="openPossibleResolutionDialog()">Possible Resolution</a>
  </div>
</div>